var React = require('react');

function CleanCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M52.5772 34.1924C47.5003 29.1156 39.2692 29.1156 34.1924 34.1924C29.1156 39.2692 29.1156 47.5003 34.1924 52.5771L109.499 127.884L34.1924 203.191C29.1156 208.268 29.1156 216.499 34.1924 221.576C39.2692 226.653 47.5003 226.653 52.5772 221.576L127.884 146.269L203.191 221.576C208.268 226.652 216.499 226.652 221.576 221.576C226.652 216.499 226.652 208.268 221.576 203.191L146.269 127.884L221.576 52.5772C226.652 47.5003 226.652 39.2692 221.576 34.1924C216.499 29.1156 208.268 29.1156 203.191 34.1924L127.884 109.499L52.5772 34.1924Z","fill":"#D4EFFF"}));
}

CleanCross.defaultProps = {"width":"256","height":"256","viewBox":"0 0 256 256","fill":"none"};

module.exports = CleanCross;

CleanCross.default = CleanCross;
